'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSender = undefined;

var _immutable = require('immutable');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _cmfSenderTypes = require('../../common-message-format/constants/cmfSenderTypes');

var senderTypes = _interopRequireWildcard(_cmfSenderTypes);

var _getSenderKeyFromType = require('../../common-message-format/operators/getSenderKeyFromType');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var senderTypeValues = Object.keys(senderTypes).map(function (key) {
  return senderTypes[key];
});

var buildSender = exports.buildSender = function buildSender(_ref) {
  var _Map;

  var senderType = _ref.senderType,
      senderId = _ref.senderId;

  (0, _invariant2.default)(senderTypeValues.includes(senderType), 'Invalid sender type. Should be one of ' + senderTypeValues.join(' | ') + '. Received %s', senderType);

  var senderIdKey = (0, _getSenderKeyFromType.getSenderKeyFromType)(senderType);
  return (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, _messageTypes.MESSAGE_TYPE_ID, senderType), _defineProperty(_Map, senderIdKey, senderId), _Map));
};